import { createSelector } from '@reduxjs/toolkit'
import { getTimeScheduleKey } from '@/utils/timeSchedules'
import { timeScheduleSlice } from '..'
import { visibleTimeSchedulesSelector } from './visibleTimeSchedulesSelector'

export const dialogTotalSelector = createSelector(
  [timeScheduleSlice.selectors.addedServices, visibleTimeSchedulesSelector],
  (addedServices, visibleTimeSchedules): number => {
    if (visibleTimeSchedules.length === 0) {
      return 0
    }

    return Object.values(addedServices).reduce<number>((acc, service) => {
      const key = getTimeScheduleKey(service.timeSchedule)

      const foundTimeSchedule = visibleTimeSchedules.find(
        (ts) => getTimeScheduleKey(ts) === key
      )
      if (!foundTimeSchedule) {
        return acc
      }

      return acc + foundTimeSchedule.price * service.bought
    }, 0)
  }
)
